// @ts-expect-error @headlessui/react incompatibility with node16 resolution
import {Dialog, Transition} from '@headlessui/react';
import {Fragment, ReactNode} from 'react';
import {Image} from '@shopify/hydrogen';
import {Button} from './Button.client';
import clsx from 'clsx';
import {X} from 'react-feather';
import { scaleWidth } from '~/utils';

interface RoundedModalProp {
  children: ReactNode;
  isOpen: boolean;
  confirmButtonText?: string;
  onConfirm: () => void;
  onClose: () => void;
  className?: string;
}

export function RoundedModal({
  children,
  isOpen,
  confirmButtonText = 'Confirm',
  onConfirm,
  onClose,
  className,
}: RoundedModalProp) {
  
  return (
    <Transition as={Fragment} show={isOpen} appear>
      <Dialog
        as="div"
        className="relative z-[10000] text-acai-900"
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto flex items-center justify-center">
          <div className={clsx('flex-grow max-w-[330px]', className)} style={{marginLeft: scaleWidth(40), marginRight: scaleWidth(40)}}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="transform overflow-hidden bg-foam-100 text-left align-middle shadow-xl transition-all rounded-md">
                <div className='text-center'>
                  {children}
                </div>
                <div className="flex divide-x-[0.5px] divide-[#593B37] divide-opacity-50 items-center justify-between border-t-[0.5px] border-opacity-50 border-[#593B37]">
                  <div onClick={onClose} className='w-1/2 py-[13px] text-center text-[14px] leading-[14px]'>
                    Back
                  </div>
                  <div onClick={onConfirm} className='w-1/2 py-[13px] text-center text-daybreak-400 text-[14px] leading-[14px]'>
                    {confirmButtonText}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
